import DeleteModal from '@/components/Modals/DeleteModal';
import { useAnalytics } from '@/services/analytics';
import { useDeleteTranslationGroup } from '@/state/translations';
import { useRecoilState } from 'recoil';
import { translationGroupToDelete } from '../state';

export const DeleteTranslationGroupModal = () => {
    const mixpanel = useAnalytics();
    const [itemToDelete, setItemToDelete] = useRecoilState(translationGroupToDelete);
    const { mutateAsync: deleteItem, isLoading: isDeleting } = useDeleteTranslationGroup();

    const onItemDelete = async () => {
        if (itemToDelete) {
            mixpanel?.track('translate-delete', {
                event: 'click',
                from: 'translate-page',
                id: itemToDelete.id,
                languages: itemToDelete?.target_languages,
            });

            await deleteItem(itemToDelete.id);
            setItemToDelete(null);
        }
    };

    return (
        <DeleteModal
            itemType="video"
            mode="square"
            open={!!itemToDelete}
            isLoading={isDeleting}
            onDelete={onItemDelete}
            onClose={() => setItemToDelete(null)}
            poster={itemToDelete?.thumbnail_url ?? ''}
            text={{
                title: 'Confirm delete',
                content: `Are you sure you want to delete "${itemToDelete?.name ?? 'Untitled Translations'}" from your gallery?`,
                cta: `${itemToDelete?.target_languages && itemToDelete.target_languages.length > 1 ? `Delete videos (${itemToDelete?.target_languages.length})` : 'Delete  video'}`,
            }}
        />
    );
};
